import { ArrowRight } from "lucide-react";
import type { ComponentProps, ReactNode } from "react";

import { Tk, useTranslation2 } from "~/shared/i18n";
import { cn } from "~/shared/ui";
import { Button } from "~/shared/ui/button";
import { Card, CardDescription, CardHeader, CardTitle } from "~/shared/ui/card";

type Props = ComponentProps<typeof Card> & {
  service: {
    name: ReactNode;
    description: ReactNode;
    image: ReactNode;
  };
  button?: ReactNode | undefined;
};

function ServiceCardTemplate({
  service: { name, description, image },
  button = <MoreDetailsButton />,
  className,
  ...props
}: Props) {
  return (
    <Card className={cn("pt-0", className)} {...props}>
      {image}
      <CardHeader className="flex grow flex-col gap-4 *:last:mt-auto *:last:w-full">
        <CardTitle>{name}</CardTitle>
        <CardDescription>{description}</CardDescription>
        {button}
      </CardHeader>
    </Card>
  );
}

type MoreDetailsButtonProps = ComponentProps<typeof Button>;

function MoreDetailsButton({ ...props }: MoreDetailsButtonProps) {
  const {
    postproc: { tc },
  } = useTranslation2();

  return (
    <Button variant="secondary" size="xl" {...props}>
      {tc(Tk.MORE_DETAILS)}
      <ArrowRight />
    </Button>
  );
}

export { MoreDetailsButton, ServiceCardTemplate };
